<p-table *ngIf="initialized" [value]="configs" dataKey="subject" (onRowExpand)="onRowExpand($event)" styleClass="p-datatable-striped">
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th>Subject</th>
            <th *ngFor="let previewColumnName of previewColumnNames">
                {{previewColumnName}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-config let-expanded="expanded" let-columns="columns">
        <tr>
            <td>
                <a href="#" [pRowToggler]="config" *ngIf="showExpansion">
                    <i
                        [ngClass]="expanded ? 'fa fa-fw fa-chevron-circle-down' : 'fa fa-fw fa-chevron-circle-right'"></i>
                </a>
                {{config.subject}}
            </td>
            <ng-template ngFor let-previewColumnName [ngForOf]="previewColumnNames" let-i="index">
                <td class="right">{{config.previewLabels[i]}}</td>
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-config let-columns="columns" let-i="rowIndex">
        <tr>
            <td [attr.colspan]="previewColumnNames.length + 1">
                <div class="expansion-area" fxLayout="row">
                    <p-table [value]="config.data" dataKey="label" fxFlex="1 1 30%" selectionMode="single" (onRowSelect)="onRowSelect($event)" styleClass="p-datatable-striped">
                        <ng-template pTemplate="body" let-rowData let-columns="columns">
                            <tr>
                                <td>
                                    {{rowData.label}}
                                </td>
                                <ng-template ngFor let-value [ngForOf]="rowData.values" let-i="index">
                                    <td class="right">{{rowData.values[i] | number:'1.2-2'}}</td>
                                </ng-template>
                            </tr>
                        </ng-template>
                    </p-table>
                    <div class="chartwrapper liquitics-box">
                        <div>
                            <div [attr.id]="'heatchartdiv'+i" class="chartdiv"></div>
                        </div>
                    </div>
                    <div class="chartwrapper liquitics-box" fxLayout="column">
                        <div fxFlex="1 1 35vh" fxLayout="column">
                            <!-- <span class="historical-title">Historial Ranking</span> -->
                            <div [attr.id]="'historicalchartdiv'+i" class="chartdiv"></div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>
    </ng-template>
</p-table>